import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`It's been a long time...`}</p>
    <h2>{`Thanks, Jekyll`}</h2>
    <p>{`Well, Github recommends this and it does look good. With `}<a parentName="p" {...{
        "href": "https://jekyllrb.com/"
      }}>{`Jekyll`}</a>{` and github.io, I finally get something that might be prettier, faster and easier to write blog. This was on my todo list long time ago when I migrated almost all my personal logs to `}<a parentName="p" {...{
        "href": "https://daringfireball.net/projects/markdown/syntax"
      }}>{`Markdown`}</a>{`. Besides blog, I need a customizable personal webpage, that I could also upgrade all my old pages generated by `}<a parentName="p" {...{
        "href": "https://www.tug.org/begin.html"
      }}>{`TeX`}</a>{`, my personal project log (mostly in `}<a parentName="p" {...{
        "href": "https://github.com/vimwiki/vimwiki"
      }}>{`Vimwiki`}</a>{`, Vim's `}<a parentName="p" {...{
        "href": "http://orgmode.org/"
      }}>{`orgmode`}</a>{`) in markdown, resume and many other things like social media etc., so that I could just write once and distribute as I need. After some research, Jekyll seems to offer most I need. `}</p>
    {/* 
     My folder structure is like, under Vimwiki (my personal private wiki): 
     */}
    <h2>{`... and Many Others`}</h2>
    <p>{`FrontEnd world is like a bazzar, a lot of fancy goodies that doesn't require any js programming to put them together. `}<a parentName="p" {...{
        "href": "https://getmdl.io/"
      }}>{`MDL`}</a>{` seems very cool to give a shot; `}<a parentName="p" {...{
        "href": "http://getbootstrap.com/"
      }}>{`Bootstrap`}</a>{` is very basic and `}<a parentName="p" {...{
        "href": "http://fancybox.net/"
      }}>{`Fancybox`}</a>{` also helps for images; and many more are honored in footer page. Maybe eventually I'll rewrite front end into single page app, but for now, I'm fine with this blog work flow. At last besides these front end goodies, I think it's cooler to add `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API"
      }}>{`WebGL`}</a>{` js code to show my taste of website 😀.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/e3960c0cc0a3e5d9abd0aef7b4ccee10/f868f/paint-house.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "96%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAABYlAAAWJQFJUiTwAAAFE0lEQVQ4y0WU11OUVxiH95/IRTSTONEMiWFpC+yyu7Jsr+xSRAQUY4kaYgENjKKIOBmNfeIoEkBpBqSoiIIooBRjZYGlifQmWGIhmusnB25y8c07c86Z53t+57znSOR2B9JQDQGhapQGLVqLAbPDjN1lJiLaSnSUkQ2JEWzaEMOaBCeJa12iuoiLcxKzyo4r0oTWqsdfp0OqMyJRhjtZHqrDe4WWAJ2JYJMVhdmO3GRBJhYEajSoxY/81Sp8VSH4qxT4K+X4KgLxDvRlmb8fS+Uqvg8zILPYkZiiIpFqjfjODxisyM0OVDbnwhciwMEGC/5iTroijOWqFXgpVCwLUvCln4zPvvVmkY+M74SMzOJAHbESiSsqfMEqQG/C7HJgi3RhiYjA4HQSarURYjQTpDPgOw9UzgPVAhjCEpmcRVJ/vpIJY6MNTXQspvi1SOwOA0qrnSAx6IpysHF9HEmbE9m6KZ6NP8QQu8qBS+ynxaZDZ9KgMWhQatX4qFQs9gnESxmGPiaeqI1biN2aJIB2PSECKDPYiYiL5ULeSaor86ipzKW5toCG6lyKcw5zJCuVg3uT2Z+6lZRt65Fp9Sz2DUZudbJu206279nHtj3pSBzh84bh+GktbNr2M33dTUxNPGFypI0Pr58y9+oJs32NdLVex33vOq11pdyqykUbEc3nfgpsCev49dgJTp05y+ETJ5GEO00oBFCqMZKUmsHU5CQvX71kYuoZs7PPeP3Cw8xwB+7H9xnsdOMRta2xBn30ahYHqFn5YxI5Fy5SUlrGHxcvInGK/VFYXXiHmtialsXE+BQvpqcZHe1nerKfiWE30yPddD55zICnB097O23Nd9BGx/NFUBhxSSnkFhZTWlFJXlGxMHRZUNgi8dGY2ZyaxcDwBFNT0wwP9jI53svgQDsDfe08fviA3q4e3E/budtUj04Alyj0rNmRRm7RJUrKK0QVQLuILBdAqcbEpl0H6RuYYmx0iqGBfsZGehl63kl/j5uW5mbcT9w8fPCQW/W1ApjAUpWRhOS95BSWUlhWTnZBoQCGGwm2ReEtDDfsysTTN0J/35CAeHje3ynsOujxPKWhoYFH9x/Q1tJMbd0NlK44vlabWZOyj7MFZeT9Wc6ZCwJosRv+B6ak0yPMhoYFtKeTkQE3o4NddHUIq7qbtDQ20nKviZqb11GEr+abUBuJuzM5feEy50rKOZUnDsVo0RFkjVwArt+5h0edPQwOjTD4XER+3sW4ALY/aqWirJSaq1e423ibq9evEeyIxSvMQWLqIY7nl/N7USXHcgRQbxL30BqBT5iZdclpNHZ66Bsd49nIIOMTQ8xMj9LV1U7tzZvU3bhBw+06qq5dJci+Ci+tAKYd4lh+BScKqzh8vkAYmoWhOVy0jUF0+kF6hl4w8+odL1//zcdPn5ibe8/YxDitbfdpvHNnAVhacRmp3s5StYmE3Qc5mlvKEQE9dK5wPrIwNFrx1ehITs+iW5zy7Ku3vHnzhrkP7/jw/i0doqGviLg1IurtemFYVYFrZTSBK9TE70gn/cwlss6XknFGRDYYQ1FqVCgUAWzc8hMtrQ+ZmZzm7es3/PP+Pf/OfaTf082N6mqqKiqovjZfq8Sdz+dAxn5+SU3jSHYRB7LLSDuZh0QXFkyAnxfyYCkO8VDsTtlOSUEBTbfqeXz/L7rdonW6exdqfW0dl4pLyMk+z8njxzn621EyBTQrM4PT2fmkn87lP5K4trLSl6S+AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Paint House",
            "title": "Paint House",
            "src": "/static/e3960c0cc0a3e5d9abd0aef7b4ccee10/0a47e/paint-house.png",
            "srcSet": ["/static/e3960c0cc0a3e5d9abd0aef7b4ccee10/8a4e8/paint-house.png 150w", "/static/e3960c0cc0a3e5d9abd0aef7b4ccee10/5a46d/paint-house.png 300w", "/static/e3960c0cc0a3e5d9abd0aef7b4ccee10/0a47e/paint-house.png 600w", "/static/e3960c0cc0a3e5d9abd0aef7b4ccee10/1cfc2/paint-house.png 900w", "/static/e3960c0cc0a3e5d9abd0aef7b4ccee10/c1b63/paint-house.png 1200w", "/static/e3960c0cc0a3e5d9abd0aef7b4ccee10/f868f/paint-house.png 1382w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Paint House`}</figcaption>{`
  `}</figure>
    <h2>{`Design`}</h2>
    <p>{`For layout, I need to keep in mind: mobile-first-or-at-least-very-important and power friendly (WebGL ~10FPS).
Therefore, I chose the safer way to start with Jekyll's minimia theme (basically scratch) and built this fancier webpage by adding all other components one after another. It's also a learning process of fun. `}</p>
    <p>{`The color was inspired by my day dream in summer time, laying under the cloudy and not-hot-at-all sun, and looking at the ocean under the sky, with a refreshing cool drink in hand. Anyway, it's hot summer outside now, and I apparently like this color and also painted one of my room like this...`}</p>
    <img {...{
      "src": "/a87b60ce2fefefd50660cb19b82413fe/ocean-top-bar.gif",
      "alt": "*Ocean Top Bar*, **IT'S WEBGL, NOT GIF!** "
    }}></img>
    <p>{`After all these efforts, I hope most people will agree that the new webpage and the painted room looks much better than before 😅! `}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/61664361fafd3580f871680688fa347b/eb1d2/old-web-page.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAABYlAAAWJQFJUiTwAAADI0lEQVQ4y4WT328UVRTHr7Gl0CKSKDwolOJasNCWUBPCk2FD0+0PDVEKARI0QCPBFEyoPlggjUgMP/qAbyYqYnwzMY3R1NDqP2C0UhJKu3RnurPLdru7s1vabjs7P/bD7cy226DRm3zmzD3n3u+dc+4Z8c2tb/Hve4PW1haamwPLBAq2KVD0tbR4BKSvqckj4Mab8fv9/NL/K6L7QjdVGwR7awU7qgS+lwSvvuzZ3dsENVsEta8Itm8WVG/y3ut8cv1OwevbBUIU+errW4ienkvuZF25oKJMUL5a8NwawVrJugrB+rXFecVirNzzvbhe8MLzgtWrJGWe4O3vbiOUoV7UgWrGf9/DvZ9qUAZ3Mdy3lbt9Psbu1EnqGfrRx0j/Tu71VaIOvkZ4YDPqHQ9tUPJbJdrARiKjPyCm4mG+vHmR3k/Pcv3zj+n/+XtY0DDif2En/8ZJ/ImVHMbOjIKjS1JARjJdYKbANOl0AjEeUqn1bWVjiWBVaRmdnefIGSZTsUlmYipZbYTpxCTpVJp0ZpaU/hjTgryUsG2wDAvbtHGkI6lnECFFofGQn87LRzm8t4FDBw7wvyPvuMacn2d+SsWcjrm+lJ6WgqqKv30/pz57l4ZqH0feOeguXtySX0k+/w+eHq5gJKLR3XWa8+c7OHG8nRu918HIkI3el3V8iL0wg2Ma/yq4JLpkXcFoNMq5949x/HCAg2/t49qVHnKPE8SDQ0yODaFP3MeaSxc3rhBypLWNrMzWKgoq2iO6PvyAsyfe5r0jLVy98IkbtPIezn+U0rIdFvQoTm7enScXBbVojMsXP6LrzDE6TrbzxdUr3umW6Z6cty0cF9NN3TFznpVxr7pLz8IXqhMTtLYFqKvbQdWWSk6e6pB9qDMT+oNseJi58F3XLsSD5PQIuXSUXEojl5l0019x9YVbDik07K7hmcL/uL+x0a1LJPSAePghj9QgMeUBiVhEbtBJJlMkEgmy2ayb8mx0ZLnGSdmrbmPX76qnpPRZSstKeLOtjdm5OUbHgkyENRRFJSQZlwcroRDB4JgkiGEYsrEdsrIPrVl9WfAJYziN6X3ikpIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Old Webpage",
            "title": "Old Webpage",
            "src": "/static/61664361fafd3580f871680688fa347b/0a47e/old-web-page.png",
            "srcSet": ["/static/61664361fafd3580f871680688fa347b/8a4e8/old-web-page.png 150w", "/static/61664361fafd3580f871680688fa347b/5a46d/old-web-page.png 300w", "/static/61664361fafd3580f871680688fa347b/0a47e/old-web-page.png 600w", "/static/61664361fafd3580f871680688fa347b/1cfc2/old-web-page.png 900w", "/static/61664361fafd3580f871680688fa347b/c1b63/old-web-page.png 1200w", "/static/61664361fafd3580f871680688fa347b/eb1d2/old-web-page.png 1622w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Old Webpage`}</figcaption>{`
  `}</figure>
    <p>{`I have to say old one has a nice color design (`}<a parentName="p" {...{
        "href": "https://uiowa.edu/"
      }}>{`UIowa`}</a>{`'s Black and Gold) though... You might still see some of the old pages, not upgraded, around. As comparison, here is the new page screenshot :`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d183a078f6d1c4aed6c4d383faafeb40/966ce/new-web-page.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAAC30lEQVQ4y3WTS08TYRSGm7gzcSNqTNyQGH+EP8CVC6MuXWo0JiasMCYYSIiXn2CiEhFBAxYxpYkJUgTKpe20pfR+mUunlym9zbTTAr1M+3pmCoqAk7w5X79MnznnPeeYLOtbmN/wYca2iamFVYxbF/HBaoN53YcvywzGf6zAvObDN2cIn1c8mF71wOIKw8KEYaaz1RnELz+LgCBh0x+FSVFr0ADY7TYMPLyNZwP3MDT4AEuebdi8QUOOuAiGSxtyJlIUM/BnSwhJJSi1XdT3G1B391Cp1WHS2i3oj2t9EYP3b2D4yS08fXwHW5yIWF5BJFcGW1INcYcq18DLdSRJnU7H+H+XYrvVgqnVahoXYjKB71/fwzo3jrnZCQSFNFgC8qUquGIFPIkrKHQnG0qQ+IKMVruNbreLNsVGswlTs9kDBoIBDD0fwvDICEZGXyAqZpDMl8FJeXC5AsUC0qUKpEodWUVFulyFJKvQtM4foM4yNRoNAzhrnkbfuTO4fP4sLl3sw4LDi41QAmuBGOxkti5nTIAvKcGf2kGiVKPS1X8yPADuG8CpTxO41n8Bd29ex9X+K1j2BrAt5sCwWbjjAhhqhpvPISBKCGUKhqfCEaCmaVAU5W/JSyt2zFqmkBJdGH39Ekw8ieiOjHhRRbxQoVg1smKpISxF/TdLOgqUZRkmPVXqEZpaFxl5FyK9VKUrkfxLFWVkSgp5pxjnVKF3d6hsWTnpod5q/ZHzIgRmDpE1M3z2eRpUEQ7y0EPl+pNZBFO9cvXupqp7EOQaklRyu60dB/ZKlgUvBPtHMPafmHn1CK5gCItuPxwRFlt8Bl4aah+B9bOu6A6NFJV/oimtgwyzfBwzk2MYm5zEu7dv4CSQi7rqJi8Zigxl6oryxgecUc4YeuE0YM9DyrC+jwh9NaYPLnkZpE6Gs0VjKw7FHmyJcda3paT+H6gQMEEv6CvF0naEpaJRWpwyOYQd12nA3/Xa5o3QPMuBAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "New Webpage",
            "title": "New Webpage",
            "src": "/static/d183a078f6d1c4aed6c4d383faafeb40/0a47e/new-web-page.png",
            "srcSet": ["/static/d183a078f6d1c4aed6c4d383faafeb40/8a4e8/new-web-page.png 150w", "/static/d183a078f6d1c4aed6c4d383faafeb40/5a46d/new-web-page.png 300w", "/static/d183a078f6d1c4aed6c4d383faafeb40/0a47e/new-web-page.png 600w", "/static/d183a078f6d1c4aed6c4d383faafeb40/1cfc2/new-web-page.png 900w", "/static/d183a078f6d1c4aed6c4d383faafeb40/c1b63/new-web-page.png 1200w", "/static/d183a078f6d1c4aed6c4d383faafeb40/966ce/new-web-page.png 2050w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`New Webpage`}</figcaption>{`
  `}</figure>
    <p>{`What I feel most unique is the top bar with procedural ocean waves (even though we could have long argue for gif animation vs webgl). It's the lake/ocean `}<a parentName="p" {...{
        "href": "https://www.shadertoy.com/view/XdXcDf"
      }}>{`ShaderToy`}</a>{` with some modification to coporate nicely with others. I also tried to reduce the framerate, and adjust the shader paramters so it fits my top bar. If there's no WebGL available, it could fall back to the plain old background. At last of course, to make sure it runs on all types of modern devices!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      